import styled from 'styled-components';
import PropTypes from 'prop-types';
import imageHelper from '@utils/imageHelper';
import Button from '@base/Button/Button';

const Container = styled.div`
  padding: 32px 16px 24px;
  text-align: center;
`;

const Img = styled.img`
  user-select: none;
  user-drag: none;
  margin-bottom: 16px;
`;

const Title = styled.h1`
  font-size: 20px;
  line-height: 120%;
  color: ${({ $color }) => $color || '#3C4852'};
  margin: 0;
`;

const SubTitle = styled.p`
  font-size: 14px;
  line-height: 150%;
  color: ${({ $color }) => $color || '#3C4852'};
  margin: 0;
  margin-top: 4px;
  margin-bottom: 24px;
`;

const ClassBooked = ({ phoneNumber, handleClick }) => (
  <Container>
    <Img
      src={imageHelper.getImage('leadGen/booked.png')}
      alt="alert"
      width="64"
      height="64"
    />
    <Title>You’ve booked a class already</Title>
    <SubTitle>
      {`A free class has already been booked using mobile number +91-${phoneNumber}`}
    </SubTitle>
    <Button width="100%" label="Got it" onClick={handleClick} />
  </Container>
);

ClassBooked.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired
};

export default ClassBooked;
